import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

/**
 * Placeholder de carga.
 *
 * Envuelve `nz-skeleton` para que las plantillas de feature no mencionen ng-zorro: así el
 * kit visual puede sustituirse por su equivalente Ionic intercambiando el barrel
 * `@shared/shared-standalone` en el build, sin tocar una sola plantilla.
 */
@Component({
  standalone: true,
  selector: 'app-skeleton',
  imports: [NzSkeletonModule],
  template: `
    <nz-skeleton [nzActive]="active()"></nz-skeleton>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSkeletonComponent {
  /** Animación de carga. Activa por defecto, que es como se usaba en las 19 plantillas. */
  active = input<boolean>(true);
}
